import { ca } from '@cian/analytics';

export const trackLegalBannerClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'LegalReview',
    action: 'Click',
    label: 'OrderButton',
    page: {
      pageType: 'Card',
      device_type: 'desktop',
    },
  });
};
